import { requestConstantsMaker } from '../helper';

export const REGISTER = requestConstantsMaker('REGISTER');
export const GET_CUSTOMER = requestConstantsMaker('GET_CUSTOMER');
export const UPDATE_CUSTOMER = requestConstantsMaker('UPDATE_CUSTOMER');
export const CHANGE_PASSWORD = requestConstantsMaker('CHANGE_PASSWORD');
export const CHECK_REGISTRATION_PROCESS = requestConstantsMaker('CHECK_REGISTRATION_PROCESS');
export const SEND_RESET_PASSWORD_EMAIL = requestConstantsMaker('SEND_RESET_PASSWORD_EMAIL');
export const RESET_PASSWORD = requestConstantsMaker('RESET_PASSWORD');
